import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import Dialog from "@mui/material/Dialog";
import axios from "axios";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MDButton from "components/MDButton";
import { useState, useEffect } from "react";
import MDBackdrop from "components/MDBackdrop";
import { useSnackbar } from "notistack";

import CloseIcon from '@mui/icons-material/Close';
import { useMaterialUIController } from "context";
import theme from "assets/theme";
import IconButton from '@mui/material/IconButton';
function PopAddStopSession(props) {


    const [controller] = useMaterialUIController();
    const { darkMode, sidenavColor } = controller;

    const [isBackdrop] = useState(false);
    const { onClose } = props;

    const { enqueueSnackbar } = useSnackbar();

    const createUser = (charger_id, session_id, reason) => {

        const payload = {
            "action": "stop",
            "chargerId": charger_id,
            "payload": {
                "sessionId": session_id,
            },
            "sessionReason": reason
        };
        axios({
            method: "post",
            url: process.env.REACT_APP_BASEURL + "session/transaction",
            data: payload,
            withCredentials: true,

        })
            .then((response) => {
                if (response.data.status) {
                    enqueueSnackbar(response.data.message, { variant: 'success' });

                    window.location.reload();
                } else {
                    enqueueSnackbar(response.data.message, { variant: 'error' });

                }
            })
            .catch((error) => {
                enqueueSnackbar("An error occurred while stopping the charger.", { variant: 'error' });

            });
    };

    console.log("Props", props);

    const [values, setValues] = useState(props.value);
    useEffect(() => {
        if (props.value) {
            setValues(props.value);
        }
    }, [props.value]);
    const handleChange = (event) => {
        setValues((prevValues) => ({
            ...prevValues,
            [event.target.name]: event.target.value,
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        // if (!values.charger_id || !values.session_id || !values.reason) return enqueueSnackbar('Please Fill All The Details !!!', { variant: 'error' })
        createUser(values.charger_id, values.session_id, values.reason);
    };
    const handleClose = () => {
        onClose(false);
    };


    return (
        <>
            <MDBackdrop isBackdrop={isBackdrop} />
            <Dialog open={props.isDialog} onClose={handleClose} fullWidth={false}   // stop stretching
                PaperProps={{
                    sx: {
                        width: 1000,     // exact width (adjust if needed)
                        borderRadius: "12px",
                    },
                }} >
                <DialogTitle style={darkMode ? { backgroundColor: "#202940", color: "#ffffff", display: "flex", alignItems: "center", justifyContent: "space-between" } : { theme, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    {/* <IconButton aria-label="delete" onClick={back} style={darkMode ? {color: "#ffffff"} : theme}>
                        <ArrowBackIcon />
                    </IconButton> */}
                    Stop Session
                    <IconButton aria-label="delete" onClick={handleClose} style={darkMode ? { color: "#ffffff" } : theme}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent style={darkMode ? { backgroundColor: "#202940", color: "#ffffff" } : theme}>
                    <MDBox pt={0} pb={0} px={3}>
                        <MDBox pt={0}>
                        </MDBox>
                        <MDBox p={2} component="form" role="form">
                            {/* <MDBox p={1}>
                                <MDInput
                                    type="text"
                                    label="Mobile number / Tag ID"
                                    placeholder="Enter mobile number / Tag ID"
                                    value={values.tag_id}
                                    name="tag_id"
                                    margin="dense"
                                    fullWidth={true}
                                    onChange={handleChange}
                                />
                            </MDBox> */}

                            {/* <MDBox p={1}>
                                <MDInput
                                    type="text"
                                    label="Location"
                                    value={values.location}
                                    name="location"
                                    
                                    
                                    margin="dense"
                                    fullWidth={true}
                                    onChange={handleChange}
                                />
                            </MDBox> */}

                            {/* <MDBox p={1}>
                                <MDInput
                                    type="text"
                                    label="Charger name / ID"
                                    value={values.charger_id}
                                    name="charger_id"
                                    
                                    
                                    margin="dense"
                                    fullWidth={true}
                                    onChange={handleChange}
                                />
                            </MDBox> */}
                            {/* <MDBox p={1}>
                                <MDInput
                                    type="text"
                                    label="Session ID"
                                    value={values.session_id}
                                    name="session_id"
                                    
                                    
                                    margin="dense"
                                    fullWidth={true}
                                    onChange={handleChange}
                                />
                            </MDBox> */}
                            <MDBox p={1}>
                                <MDInput
                                    type="text"
                                    label="Stop reason"
                                    value={values.reason}
                                    name="reason"
                                    multiline
                                    rows={5}
                                    placeholder="Enter stop reason"
                                    margin="dense"
                                    fullWidth={true}
                                    onChange={handleChange}
                                />
                            </MDBox>
                        </MDBox>
                    </MDBox>
                </DialogContent>
                <DialogActions style={darkMode ? { backgroundColor: "#202940", justifyContent: "space-evenly", color: "#ffffff" } : { theme, justifyContent: "space-evenly" }}>
                    <MDButton style={{ width: "87%", }} variant="gradient" color={sidenavColor}
                        onClick={handleSubmit}
                    >
                        STOP
                    </MDButton>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default PopAddStopSession;